import { useMutation, useQuery } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { PROVIDER_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { routeReplacer } from '~/Helpers/String.helper';

interface IFirstFreeCheckin {
  locationSetting: {
    locationUuid: string;
    isFirstCheckInFree: boolean;
  };
}

export const useRequestFirstFreeCheckin = (locationId: string, enabled: boolean = true) => {
  const query = useQuery(
    [REQUEST_ACTIONS.LOCATION_FIRST_FREE_CHECKIN, locationId],
    async () =>
      requestReactQuery<IFirstFreeCheckin>({
        url: routeReplacer(PROVIDER_SERVICE_URLS.GET_LOCATION_FIRST_FREE_CHECKIN, {
          locationId,
        }),
        config: { method: 'GET' },
      }),
    {
      enabled,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: true,
      retry: false,
    },
  );

  return {
    ...query,
    data: query.error ? null : query.data,
  };
};

export const useUpdateFirstFreeCheckin = () =>
  useMutation(
    async ({
      locationId,
      isFirstCheckInFree,
    }: {
      locationId: string;
      isFirstCheckInFree: boolean;
    }) =>
      requestReactQuery({
        url: PROVIDER_SERVICE_URLS.UPDATE_LOCATION_FIRST_FREE_CHECKIN,
        config: {
          method: 'POST',
          data: {
            LocationUuid: locationId,
            isFirstCheckInFree,
          },
        },
      }),
  );
